'use client';

import type {
  PageViewDestination,
  Placement,
  ProductType,
} from '@hc-frontend/core-types';
import { useEventBus } from '@hc-frontend/core-ui';
import type {
  SendMetricEvent,
  SendMetricEventTarget,
} from '@hc-frontend/shells-shared';
import { useEffect } from 'react';

export function PageViewMetric({
  placement,
  destination,
  product,
}: {
  placement: Placement;
  product: ProductType;
  destination: PageViewDestination;
}) {
  const eventBus = useEventBus();

  useEffect(() => {
    const { hostname, pathname, protocol, search } = window.location;
    const hostnameAndPath = `${protocol}//${hostname}${pathname}`;
    window.sessionStorage.setItem('SAVED_TYP', pathname + search);
    const referrer = document.referrer.split('?')[0];
    eventBus.publish<SendMetricEvent, SendMetricEventTarget>({
      id: 'page-view',
      topic: 'metric.client.message',
      source: hostnameAndPath,
      metric: {
        name: 'page-view',
        tags: {
          placement,
          destination,
          domain: hostname,
          pageUrl: hostnameAndPath,
          platform: 'apollo',
          product,
          referrer,
        },
      },
    });
  }, [eventBus, destination, placement, product]);

  return null;
}
